import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { GovtServersPageComponent } from './govt-servers-page.component';

const routes: Routes = [
  {
    path: 'govt-servers',
    data: { name: 'Government-Servers', isTab: false },
    component: GovtServersPageComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GovtServersPageRoutingModule {}
